import Swiper from 'swiper';
import 'swiper/css';
import { Mousewheel, Keyboard } from 'swiper/modules';

const swiperThreeColumnBlocks = document.querySelectorAll('section.three-column-block .swiper');

if (swiperThreeColumnBlocks.length) {
  swiperThreeColumnBlocks.forEach(swiperContainer => {
    const breakpoint = window.matchMedia('(min-width: 850px)');
    let swiperInstance = null;

    const enableSwiper = () => {
      swiperInstance = new Swiper(swiperContainer, {
        modules: [Mousewheel, Keyboard],
        direction: 'horizontal',
        spaceBetween: 15,
        slidesPerView: 1.2,
        slidesOffsetAfter: 20,

        mousewheel: {
          forceToAxis: true,
          sensitivity: 1,
        },

        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },

        breakpoints: {
          550: {
            slidesPerView: 1.5,
            spaceBetween: 25,
          },
          650: { 
            slidesPerView: 1.5, 
            spaceBetween: 15 
          },
          720: { 
            slidesPerView: 2.15, 
            spaceBetween: 20 
          },
        },
      });
    };

    const destroySwiper = () => {
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    };

    const toggleSwiper = () => {
      if (breakpoint.matches) {
        destroySwiper();
      } else {
        enableSwiper();
      }
    };

    toggleSwiper();
    breakpoint.addEventListener('change', toggleSwiper);
  });
}
